"use client"
import { useEffect, useState } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"

const MobileSupportSlider = () => {
  const [padding, setpadding] = useState(0)

  useEffect(() => {
    setpadding((globalThis.window.innerWidth - 24 - 280 + 12) / 2)
  }, [])

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: `${padding}px`, // Adjust this value to show more or less of the sides
  }

  return (
    <div className="w-full overflow-hidden pt-[48px] lg_hidden">
      <h2 className="mb-[24px] text-center text-[24px] font-[700] leading-[28px] text-title">
        Remarkably support
      </h2>

      <Slider {...settings}>
        <div>
          <div className="mx-[6px]">
            <div className="shadow-highlights flex flex-col items-center rounded-[12px] bg-white px-[16px] pb-[24px] pt-[24px]">
              <img
                className="mb-[16px] block h-[72px] w-auto"
                src="/icons/support-1.svg"
              />
              <p className="mb-[6px] text-center text-[32px] font-[700] leading-[40px] text-primary">
                10,000+
              </p>
              <p className="mb-[6px] text-center font-[700] leading-[20px] text-title">
                Bird Species{" "}
              </p>
              <p className="leading-[18px] text-[#3E3E3E]">
                Intelligent and powerful.
              </p>
            </div>
          </div>
        </div>
        <div>
          <div className="mx-[6px]">
            <div className="shadow-highlights flex flex-col items-center rounded-[12px] bg-white px-[16px] pb-[24px] pt-[24px]">
              <img
                className="mb-[16px] block h-[72px] w-auto"
                src="/icons/support-2.svg"
              />
              <p className="mb-[6px] text-center text-[32px] font-[700] leading-[40px] text-primary">
                Free{" "}
              </p>
              <p className="mb-[6px] text-center font-[700] leading-[20px] text-title">
                ID Service{" "}
              </p>
              <p className="leading-[18px] text-[#3E3E3E]">
                Name every guest.{" "}
              </p>
            </div>
          </div>
        </div>
        <div>
          <div className="mx-[6px]">
            <div className="shadow-highlights flex flex-col items-center rounded-[12px] bg-white px-[16px] pb-[24px] pt-[24px]">
              <img
                className="mb-[16px] block h-[72px] w-auto"
                src="/icons/support-3.svg"
              />
              <p className="mb-[6px] text-center text-[32px] font-[700] leading-[40px] text-primary">
                Free{" "}
              </p>
              <p className="mb-[6px] text-center font-[700] leading-[20px] text-title">
                Cloud Storage{" "}
              </p>
              <p className="leading-[18px] text-[#3E3E3E]">
                Endless space to play.{" "}
              </p>
            </div>
          </div>
        </div>
      </Slider>
    </div>
  )
}

export default MobileSupportSlider
